import { DictionaryBase } from './types';
const SysUserStatus = new DictionaryBase('用户状态', [
    {
        id: 0,
        name: '正常状态',
        symbol: 'NORMAL',
    },
    {
        id: 1,
        name: '锁定状态',
        symbol: 'LOCKED',
    },
]);
// const SysDeptType = new DictionaryBase('机构类型', [
//   {
//     id: '平台',
//     name: '平台公司',
//     symbol: 'PLATFORM',
//   },
//   {
//     id: '代理',
//     name: '代理公司',
//     symbol: 'AGENCY',
//   },
//   {
//     id: '进仓',
//     name: '进仓公司',
//     symbol: 'DEPARTMENT',
//   },
// ]);
const AppType = new DictionaryBase('平台类型', [
    {
        id: 'web',
        name: 'Web平台',
        symbol: 'WEB',
    },
    {
        id: 'wechat',
        name: '小程序',
        symbol: 'WECHAT',
    },
    {
        id: 'pda',
        name: 'PDA',
        symbol: 'PDA',
    },
]);
const SysUserType = new DictionaryBase('用户类型', [
    // {
    //   id: 0,
    //   name: '超级管理员',
    //   symbol: 'ADMIN',
    // },
    {
        id: 1,
        name: '机构管理员',
        symbol: 'SYSTEM',
    },
    {
        id: 2,
        name: '部门管理员',
        symbol: 'OPERATOR',
    },
    {
        id: 3,
        name: '普通操作员',
        symbol: 'OPERATOR',
    },
]);
const SysOperationType = new DictionaryBase('操作日志操作类型', [
    {
        id: 0,
        name: '登录',
        symbol: 'LOGIN',
    },
    {
        id: 1,
        name: '手机登录',
        symbol: 'MOBILE_LOGIN',
    },
    {
        id: 5,
        name: '登出',
        symbol: 'LOGOUT',
    },
    {
        id: 10,
        name: '新增',
        symbol: 'ADD',
    },
    {
        id: 15,
        name: '修改',
        symbol: 'UPDATE',
    },
    {
        id: 20,
        name: '删除',
        symbol: 'DELETE',
    },
    {
        id: 35,
        name: '查询',
        symbol: 'LIST',
    },
    {
        id: 40,
        name: '分组查询',
        symbol: 'LIST_WITH_GROUP',
    },
    {
        id: 45,
        name: '导出',
        symbol: 'EXPORT',
    },
    {
        id: 50,
        name: '上传',
        symbol: 'UPLOAD',
    },
    {
        id: 55,
        name: '下载',
        symbol: 'DOWNLOAD',
    },
    {
        id: 60,
        name: '重置缓存',
        symbol: 'RELOAD_CACHE',
    },
]);
const SysPermModuleType = new DictionaryBase('权限分组类型', [
    {
        id: 0,
        name: '分组模块',
        symbol: 'GROUP',
    },
    {
        id: 1,
        name: '接口模块',
        symbol: 'CONTROLLER',
    },
]);
/**
 * 菜单类型
 *
 * DIRECTORY(0: 目录)
 * MENU(1: 表单)
 * FRAGMENT(2: 片段)
 * BUTTON(3: 按钮)
 */
const SysMenuType = new DictionaryBase('菜单类型', [
    {
        id: 0,
        name: '目录',
        symbol: 'DIRECTORY',
    },
    {
        id: 1,
        name: '菜单',
        symbol: 'MENU',
    },
    {
        id: 2,
        name: '片段',
        symbol: 'FRAGMENT',
    },
    {
        id: 3,
        name: '按钮',
        symbol: 'BUTTON',
    },
]);
const MobileEntryType = new DictionaryBase('移动端首页配置项类型', [
    {
        id: 0,
        name: '轮播图',
        symbol: 'BANNER',
    },
    {
        id: 1,
        name: '九宫格',
        symbol: 'SUDOKU',
    },
    {
        id: 2,
        name: '分组',
        symbol: 'GROUP',
    },
]);
/**
 * 菜单绑定类型
 *
 * ROUTER(0: 路由菜单)
 * THRID_URL(4: 外部链接)
 */
const SysMenuBindType = new DictionaryBase('菜单绑定类型', [
    {
        id: 0,
        name: '路由菜单',
        symbol: 'ROUTER',
    },
    {
        id: 4,
        name: '外部链接',
        symbol: 'THRID_URL',
    },
]);
const SysDataPermType = new DictionaryBase('数据权限类型', [
    {
        id: 0,
        name: '查看全部',
        symbol: 'ALL',
    },
    {
        id: 1,
        name: '仅看自己',
        symbol: 'ONLY_USER',
    },
    {
        id: 2,
        name: '仅看所在机构',
        symbol: 'ONLY_DEPT',
    },
    {
        id: 3,
        name: '仅看所在机构及子机构',
        symbol: 'ONLY_DEPT_AND_CHILD',
    },
    {
        id: 4,
        name: '自选机构及子机构',
        symbol: 'CUSTOM_DEPT_AND_CHILD',
    },
    {
        id: 5,
        name: '仅自选机构',
        symbol: 'CUSTOM_DEPT',
    },
    {
        id: 6,
        name: '本机构用户',
        symbol: 'DEPT_USER',
    },
    {
        id: 7,
        name: '本机构及子机构用户',
        symbol: 'DEPT_AND_CHILD_USER',
    },
]);
const SysPermCodeType = new DictionaryBase('权限字类型', [
    {
        id: 0,
        name: '表单',
        symbol: 'FORM',
    },
    {
        id: 1,
        name: '片段',
        symbol: 'FRAGMENT',
    },
    {
        id: 2,
        name: '操作',
        symbol: 'OPERATION',
    },
]);
export { SysUserStatus, SysUserType, SysDataPermType, SysOperationType, SysPermModuleType, SysMenuBindType, MobileEntryType, SysMenuType, 
//SysDeptType,
SysPermCodeType, AppType, };
